export default __webpack_public_path__ + "static/media/AetherPhoto5.1f4d806c.jpg";